import React, {Component} from "react";
import SportIcon from "../../../components/SportIcon";

class EventHeader extends Component {

	render() {
		const {sport} = this.props;

		return (
			<div className={`events__header thead`}>
				<div className="tr">
					<div className="th sportname">
						<span className="sport-icon small green events__header__sporticon">
							<SportIcon sportId={sport.id}/>
						</span>
						<span>&nbsp;{sport.name}</span>
					</div>
				</div>
			</div>
		);
	}
}

export default EventHeader;


// WEBPACK FOOTER //
// ./src/app/pages/LiveSoon/modules/EventHeader.js